var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-kng-point__cell mb12" },
    [
      _vm.isEdit
        ? [
            _c("form-point-form", {
              attrs: { form: _vm.temp, "insert-hidden": "" },
            }),
            _c(
              "div",
              { staticClass: "mt20" },
              [
                _c(
                  "yxt-button",
                  {
                    attrs: {
                      type: "second",
                      disabled: !_vm.temp.time || !_vm.temp.desc,
                    },
                    on: { click: _vm.save },
                  },
                  [_vm._v(_vm._s(_vm.$t("pc_save" /** 保存 */)))]
                ),
                _c("yxt-button", { on: { click: _vm.cancel } }, [
                  _vm._v(_vm._s(_vm.$t("pc_biz_comment_cancel" /** 取消 */))),
                ]),
              ],
              1
            ),
          ]
        : _c(
            "div",
            { staticClass: "yxtbiz-flex" },
            [
              _c("div", [
                _vm._v(_vm._s(_vm.getDurationFormat(_vm.cellData.markTime))),
              ]),
              _c("div", { staticClass: "ml16 break yxtbiz-flex-1" }, [
                _vm._v("\n      " + _vm._s(_vm.cellData.markDesc) + "\n    "),
              ]),
              _c("yxt-svg", {
                staticClass: "ml16 hand",
                attrs: {
                  width: "16px",
                  height: "16px",
                  "icon-class": "common_edit",
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.edit.apply(null, arguments)
                  },
                },
              }),
              _c("yxt-svg", {
                staticClass: "ml12 hand",
                attrs: {
                  width: "16px",
                  height: "16px",
                  "icon-class": "common_delete",
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.del.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }